module.exports = __webpack_public_path__ + "img/strelka-krivaya.fc15eeab.png";